var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "elevation-1 mt-10 mb-7"
  }, [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Traveler Categories")]), _c('v-tooltip', {
    attrs: {
      "content-class": "tooltip black",
      "max-width": "480",
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-icon', _vm._g(_vm._b({
          staticClass: "ml-2",
          attrs: {
            "small": ""
          }
        }, 'v-icon', attrs, false), on), [_vm._v("mdi-information-outline")])];
      }
    }])
  }, [_c('span', [_vm._v(" Anything not listed here stays as-is. Within a category, leaving a field on \"Default\" or leaving age blank means the default value is kept. ")])]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "accent",
      "dark": ""
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v(" New Item ")])], 1), _vm.data.length ? _c('v-expansion-panels', {
    staticClass: "px-4 pb-4",
    attrs: {
      "accordion": "",
      "multiple": "",
      "flat": ""
    },
    model: {
      value: _vm.openPanels,
      callback: function ($$v) {
        _vm.openPanels = $$v;
      },
      expression: "openPanels"
    }
  }, _vm._l(_vm.data, function (item, index) {
    return _c('v-expansion-panel', {
      key: index,
      ref: "panels",
      refInFor: true,
      staticClass: "traveler-category-panel"
    }, [_c('v-expansion-panel-header', [_c('div', {
      staticClass: "d-flex align-center flex-grow-1"
    }, [_c('span', {
      staticClass: "font-weight-medium"
    }, [_vm._v(_vm._s(_vm.categoryLabel(item)))]), _c('span', {
      staticClass: "text-caption grey--text ml-3"
    }, [_vm._v(_vm._s(_vm.tabSummary(item)))]), _vm.isHidden(item) ? _c('v-chip', {
      staticClass: "ml-3",
      attrs: {
        "color": "primary",
        "x-small": "",
        "label": "",
        "outlined": ""
      }
    }, [_vm._v("Hidden")]) : _vm._e(), _c('v-spacer'), _c('v-btn', {
      staticClass: "mr-2",
      attrs: {
        "color": "primary",
        "icon": "",
        "small": ""
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.removeItem(index);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-delete")])], 1)], 1)]), _c('v-expansion-panel-content', [_c('v-row', {
      staticClass: "mx-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "4",
        "lg": "3"
      }
    }, [_c('v-select', {
      attrs: {
        "items": _vm.categories,
        "label": "Category",
        "hide-details": "auto",
        "dense": "",
        "outlined": ""
      },
      model: {
        value: item.category,
        callback: function ($$v) {
          _vm.$set(item, "category", $$v);
        },
        expression: "item.category"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "4",
        "lg": "5"
      }
    }, [_c('v-select', {
      staticClass: "traveler-category-tabs",
      attrs: {
        "value": item.tabs || [],
        "items": _vm.tabs,
        "error": !!_vm.rowConflict(index),
        "error-messages": _vm.rowConflict(index) ? [_vm.rowConflict(index)] : [],
        "label": "Tabs",
        "placeholder": "Default",
        "persistent-placeholder": "",
        "multiple": "",
        "hide-details": "auto",
        "dense": "",
        "outlined": ""
      },
      on: {
        "change": function ($event) {
          return _vm.setTabs(item, $event);
        }
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c('v-select', {
      attrs: {
        "value": _vm.flagValue(item, 'visible'),
        "items": _vm.flagOptions,
        "label": "Visible",
        "hide-details": "auto",
        "dense": "",
        "outlined": ""
      },
      on: {
        "change": function ($event) {
          return _vm.setFlag(item, 'visible', $event);
        }
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c('v-text-field', {
      attrs: {
        "disabled": _vm.isHidden(item),
        "type": "number",
        "min": "0",
        "label": "Min age",
        "hint": "Leave empty to use the default",
        "persistent-hint": "",
        "dense": "",
        "outlined": ""
      },
      model: {
        value: item.ageRangeMin,
        callback: function ($$v) {
          _vm.$set(item, "ageRangeMin", _vm._n($$v));
        },
        expression: "item.ageRangeMin"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c('v-text-field', {
      attrs: {
        "disabled": _vm.isHidden(item),
        "error": _vm.isInvalidRange(item),
        "error-messages": _vm.isInvalidRange(item) ? ['Min age cannot be greater than max age'] : [],
        "type": "number",
        "min": "0",
        "label": "Max age",
        "hint": "Leave empty to use the default",
        "persistent-hint": "",
        "dense": "",
        "outlined": ""
      },
      model: {
        value: item.ageRangeMax,
        callback: function ($$v) {
          _vm.$set(item, "ageRangeMax", _vm._n($$v));
        },
        expression: "item.ageRangeMax"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "3"
      }
    }, [_c('v-select', {
      attrs: {
        "value": _vm.flagValue(item, 'showAgeRange'),
        "items": _vm.flagOptions,
        "disabled": _vm.isHidden(item),
        "label": "Show age range",
        "hide-details": "auto",
        "dense": "",
        "outlined": ""
      },
      on: {
        "change": function ($event) {
          return _vm.setFlag(item, 'showAgeRange', $event);
        }
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "3"
      }
    }, [_c('v-select', {
      attrs: {
        "value": _vm.flagValue(item, 'showInformationText'),
        "items": _vm.flagOptions,
        "disabled": _vm.isHidden(item),
        "label": "Show information text",
        "hide-details": "auto",
        "dense": "",
        "outlined": ""
      },
      on: {
        "change": function ($event) {
          return _vm.setFlag(item, 'showInformationText', $event);
        }
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "text-caption grey--text mb-1"
    }, [_vm._v(" Information text. A language left empty keeps the default text for that language. ")]), _c('v-tabs', {
      attrs: {
        "value": _vm.localeTab(index),
        "show-arrows": ""
      },
      on: {
        "change": function ($event) {
          return _vm.setLocaleTab(index, $event);
        }
      }
    }, _vm._l(_vm.locales, function (locale) {
      return _c('v-tab', {
        key: locale.value
      }, [_vm._v(" " + _vm._s(locale.text) + " "), _vm.hasText(item, locale.value) ? _c('v-icon', {
        staticClass: "ml-1",
        attrs: {
          "x-small": "",
          "color": "greeny"
        }
      }, [_vm._v(" mdi-check-circle ")]) : _vm._e()], 1);
    }), 1), _c('v-tabs-items', {
      attrs: {
        "value": _vm.localeTab(index)
      }
    }, _vm._l(_vm.locales, function (locale) {
      return _c('v-tab-item', {
        key: locale.value
      }, [_c('vue-editor', {
        staticClass: "traveler-category-editor mt-4",
        attrs: {
          "value": _vm.textFor(item, locale.value),
          "disabled": _vm.isHidden(item),
          "editor-toolbar": _vm.informationTextToolbar
        },
        on: {
          "input": function ($event) {
            return _vm.setText(item, locale.value, $event);
          }
        }
      })], 1);
    }), 1)], 1)], 1)], 1)], 1);
  }), 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }